export default "__VITE_ASSET__7a1b4508__"